import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoad: false,
  error: null,
  messages: [],
  isSuccessful: false,
  result: null,
  needSendSatrt: false,
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    addMessage: (state, action) => {
      state.messages.push({ text: action.payload, datetime: new Date().toISOString(), direction: "in" });
    },
    addMessageFileUpload: (state, action) => {
      state.messages.push({
        text: "Идёт отправка файла...",
        datetime: new Date().toISOString(),
        direction: "in",
        fileID: action.payload,
      });
    },
    setNeedSendSatrtFalse: (state) => {
      state.needSendSatrt = false;
    },
    fillMessages: (state, action) => {
      let mes = [...action.payload].filter((x) => x.text != "/start");
      if (mes.length == 0) {
        state.needSendSatrt = true;
      }
      state.messages = mes;
    },
    pushMessages: (state, action) => {
      action.payload.forEach((element) => {
        state.messages.push({
          text: element.text,
          datetime: new Date().toISOString(),
          direction: "out",
          buttons: element.buttons,
        });
      });
    },
    uploadFileMessage: (state, action) => {
      let index = state.messages.findIndex((x) => x.fileID == action.payload.id);
      state.messages[index] = { ...state.messages[index], file: action.payload.url, text: "" };
    },
  },
  extraReducers: (builder) => {},
});

export const {
  fillSessionID,
  addMessage,
  setNeedSendSatrtFalse,
  fillMessages,
  pushMessages,
  addMessageFileUpload,
  uploadFileMessage,
} = sessionSlice.actions;
export default sessionSlice.reducer;
